import React from "react";
import Dialog from "@mui/material/Dialog";

export function FormDialog({
  children,
  open,
  handleClose,
  onSubmit,
  style = {},
}) {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: "form",
          onSubmit,
          style: {
            maxWidth: "100%",
            ...style,
          },
        }}
      >
        {children}
      </Dialog>
    </React.Fragment>
  );
}
